/* tslint:disable:no-unused-variable */
/* tslint:disable:no-unsafe-any */
const primitives = ['string', 'boolean', 'double', 'integer', 'long', 'float', 'number', 'any', 'object'];
import * as moment from 'moment';
export class ObjectSerializer {
    constructor(enumsMap, typeMap) {
        this.enumsMap = enumsMap;
        this.typeMap = typeMap;
    }
    findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === 'Date') {
            return expectedType;
        }
        else {
            if (this.enumsMap[expectedType]) {
                return expectedType;
            }
            if (!this.typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }
            // Check the discriminator
            const discriminatorProperty = this.typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            }
            else {
                if (data[discriminatorProperty]) {
                    const discriminatorType = data[discriminatorProperty];
                    if (this.typeMap[discriminatorType]) {
                        return discriminatorType; // use the type given in the discriminator
                    }
                    else {
                        return expectedType; // discriminator did not map to a type
                    }
                }
                else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }
    serialize(data, type) {
        if (data == null) {
            return data;
        }
        if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        if (type.lastIndexOf('Array<', 0) === 0) {
            // string.startsWith pre es6
            let subType = type.replace('Array<', ''); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            const transformedData = [];
            for (const element of data) {
                transformedData.push(this.serialize(element, subType));
            }
            return transformedData;
        }
        if (type === 'Date') {
            if (typeof data === 'string') {
                if (data === '') {
                    return null;
                }
                return moment.utc(data).toJSON();
            }
            if (moment.isMoment(data)) {
                return data.toJSON();
            }
            return moment.utc(data).toJSON();
        }
        if (this.enumsMap[type]) {
            return data;
        }
        if (!this.typeMap[type]) {
            // in case we dont know the type
            return data;
        }
        // Get the actual type of this object
        type = this.findCorrectType(data, type);
        // get the map for the correct type.
        const attributeTypes = this.typeMap[type].getAttributeTypeMap();
        const instance = {};
        for (const attributeType of attributeTypes) {
            instance[attributeType.baseName] = this.serialize(data[attributeType.name], attributeType.type);
        }
        return instance;
    }
    deserialize(data, type) {
        // polymorphism may change the actual type.
        type = this.findCorrectType(data, type);
        if (data == null) {
            if (type.lastIndexOf('Array<', 0) === 0)
                return [];
            return data;
        }
        if (type.lastIndexOf('Array<', 0) === 0) {
            // string.startsWith pre es6
            let subType = type.replace('Array<', ''); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            const transformedData = [];
            for (const element of data) {
                transformedData.push(this.deserialize(element, subType));
            }
            return transformedData;
        }
        if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        if (type === 'Date') {
            if (typeof data === 'string' && data === '') {
                return null;
            }
            return moment.utc(data);
        }
        if (this.enumsMap[type]) {
            // is Enum
            return data;
        }
        if (!this.typeMap[type]) {
            // dont know the type
            return data;
        }
        const instance = new this.typeMap[type]();
        const attributeTypes = this.typeMap[type].getAttributeTypeMap();
        for (const attributeType of attributeTypes) {
            instance[attributeType.name] = this.deserialize(data[attributeType.baseName], attributeType.type);
        }
        return instance;
    }
}
//# sourceMappingURL=ObjectSerializer.js.map